import { ErrorCode } from '@app/infrastructure/errors/models';
import { InformationScreenProperties } from '@app/shared/common/components/information-screen/information-screen';

export const ERROR_CODE_DETAILS_MAP: Record<ErrorCode, InformationScreenProperties> = {
  [ErrorCode.AccessDenied403]: {
    error: {
      code: '403',
      summary: 'Access denied',
    },
    message: 'You don’t have permission to view this page. Please contact your administrator.',
  },
  [ErrorCode.NotFound404]: {
    error: {
      code: '404',
      summary: 'Page not found',
    },
    message:
      'This page doesn’t exist or has been moved. Please check the URL or go back to home page.',
    action: {
      label: 'Back to Home',
      route: '/',
    },
  },
};
